// extracted by css-extract-rspack-plugin
export default {"modalContentShownAnchor":"modal-content-shown-anchor--uwv2WMmjoAObL4iO"};